// extracted by mini-css-extract-plugin
module.exports = {"page":"slug_page__454WT"};